import {
  CreateDocumentParams,
  DocumentDetailResponse,
  DocumentParams,
  GetDocumentForFlexWorkerResponse,
  GetDocumentsResponse,
  RenderDocumentResponse,
  SignDocumentDtoRequest,
} from './documents-service.types';
import { HqApiService } from './hqApiService';

class DocumentsService {
  constructor(private readonly hqApiService: HqApiService) {}

  public async getDocuments({
    pageParam,
    pageSizeParam,
  }: DocumentParams): Promise<GetDocumentsResponse> {
    const response = await this.hqApiService.get<GetDocumentsResponse>({
      path: 'documents/all',
      params: {
        page: pageParam,
        pageSize: pageSizeParam,
      },
    });
    return response;
  }

  public async renderDocument(documentId: string): Promise<RenderDocumentResponse> {
    const response = await this.hqApiService.get<RenderDocumentResponse>({
      path: `documents/render/${documentId}`,
    });
    return response;
  }

  public async createDocument({
    flexWorkerId,
    startDate,
    endDate,
    documentType,
  }: CreateDocumentParams): Promise<void> {
    const formData = {
      documentType,
      startDate,
      endDate: endDate ?? undefined,
    };

    await this.hqApiService.create<void>({
      body: formData,
      path: `documents/${flexWorkerId}/create`,
    });
  }

  public async findDocumentForFlexWorker(
    flexWorkerId: string,
    documentType: string
  ): Promise<GetDocumentForFlexWorkerResponse | null> {
    const response = await this.hqApiService.get<GetDocumentForFlexWorkerResponse | null>({
      path: `documents/${flexWorkerId}/${documentType}`,
    });
    return response;
  }

  public async getDocumentDetailById(documentId: string) {
    const response = await this.hqApiService.get<DocumentDetailResponse>({
      path: `documents/${documentId}`,
    });
    return response;
  }

  public async signDocument(documentId: string, dto: SignDocumentDtoRequest): Promise<void> {
    await this.hqApiService.update<void>({
      path: `documents/${documentId}/sign`,
      body: dto,
    });
  }
}
export { DocumentsService };
